__turbopack_context__.v({
  "account": "QuotesAndAccountBar-module-scss-module__E4ZJ4W__account",
});
